export const TestIds = {
  backdrop: 'ai-chat-drawer-backdrop',
  drawer: 'ai-chat-drawer',
  resizeHandle: 'ai-chat-drawer-resize-handle',
  header: 'ai-chat-drawer-header',
  content: 'ai-chat-drawer-content',
  contentInner: 'ai-chat-drawer-content-inner',
};
